import { useState } from 'react';
import classnames from 'classnames';
import { Button } from '../../../../components';

import img1 from './images/1.png';
import img2 from './images/2.png';
import img3 from './images/3.png';
import img4 from './images/4.png';

import collIcon from './images/whitePlayButton.png';
import videoPlayIcon from './images/customVideoPlayButton.png';


import styles from './index.module.css';

const text = {
    cn: {
        title: '客户案例',
        collapse: [
            {
                label: '"白乔丹"加盟街球霸王',
                description: 'ProLogue 合作球员，世界最著名的扣将“白乔丹”Jordan Kilganon 在2023年夏天加盟了NBA中国主办的火爆全国的街球联赛《街球霸王》全明星周末，并在扣篮大赛上以一骑绝尘之姿夺得冠军，而他的表现也引爆网络热潮，成为该项赛事的亮点之一。',
                img: img1,
                video: 'g351156mg5f'
            },
            {
                label: '比尔落户快手',
                description: '快手和Prologue的商业合作，把中国球迷最为喜爱的NBA球星比尔带到了快手平台，并且在一个小时的直播互动里，让中国的“老铁们”更加直接的和比尔进行交流，直播间气氛火爆，瞬时浏览量达到60万加。',
                img: img2,
                video: 'z3511saous8'
            },
            {
                label: 'NBA周刊',
                description: 'NBA周刊系列单元《这是可以说的吗》通过前方的镜头，向NBA球迷展现NBA季后赛紧张激烈的赛场气氛，让球迷身临其境感知淘汰赛和生死战的别样氛围。',
                img: img3,
                video: 'y3520llzg52'
            },
            {
                label: '致美之旅',
                description: '《致美之旅》是一档公路旅⾏节⽬，⾏程以凤凰城为起点，盐湖城为终点。旅途中包含【超级碗＋全明星】两⼤顶级赛事观赛体验以及特⾊城市、景点观光体验。ProLogue作为该节目的内容制作团队，负责了全部的内容制作工作。该节目在业内收获了极高的评价。',
                img: img4,
                video: 'o004528gglm'
            },
        ],
        button: '查看更多',
    },
    en: {
        title: 'Customer Case',
        collapse: [
            {
                label: 'THE START OF EUROPE',
                description: 'By entering the European football life, we build a platform for Chinese fans to have a deep understanding of European football. On the other hand, with multiple forms and interactive play, it deepens the industry image of Heineken Beer, a long-term partner of the Champions League, and brings a new paradigm for modern sports marketing.',
                img: img1,
                video: 'g351156mg5f'
            },
            {
                label: 'BRAD BEAL X KUAISHOU DEAL',
                description: 'The commercial cooperation between Kuaishou and Prologue brought Brad Beal , the NBA star most loved by Chinese fans, to the Kuaishou platform, and in the one-hour live interaction, China'+'s "old iron" more directly communicate with Bill, the atmosphere of the broadcast room is hot, and the instant page views reached 600,000.',
                img: img2,
                video: 'z3511saous8'
            },
            {
                label: 'NBA WEEK',
                description: 'NBA Weekly series unit "Can it be said" through the front of the camera, to show NBA fans the tense atmosphere of the NBA playoffs, so that fans feel the elimination of the game and life and death of the different atmosphere.',
                img: img3,
                video: 'y3520llzg52'
            },
            {
                label: 'EXPERIENCE THE POWER OF LEGEND',
                description: '“Experience The Power of Legend”is a road trip show that starts in Phoenix and ends in Salt Lake City. The trip includes the Super Bowl and the All-Star Game, as well as the sightseeing experience of featured cities and scenic spots.ProLogue, as the content production team for the show, was responsible for all the content production work and received high praise from the industry.',
                img: img4,
                video: 'o004528gglm'
            },
        ],
        button: 'View More',
    },
}

const CustomerStories = (props) => {
    const { 
        // currentIndex,
         l = 'cn', setPath } = props;
    const [checked, setChecked] = useState(0);

    return (
        <div className={styles['page']}>
            <div className={styles['background-box']}>
                <div className={styles['background1']}>&nbsp;</div>
                <div>&nbsp;</div>
            </div>
            <div
                className={styles['page-content']}
                style={{
                    // top: currentIndex === 3 ? 0 : 300,
                    // opacity: currentIndex === 3 ? 1 : 0,
                }}
            >
                <div className={styles['content']}>
                    <div className={styles['left']}>
                        <div className={styles['left-content']}>
                            <div className={styles['title']}>{text[l]['title']}</div>
                            <div className={styles['line']}>&nbsp;</div>
                            <div className={styles['collapse-box']}>
                                {text[l]['collapse'].map((item, index) => (
                                    <div
                                        className={styles['collapse-item']}
                                        onClick={() => {
                                            if (index === checked) {
                                                setChecked(0);
                                            } else {
                                                setChecked(index);
                                            }
                                        }}
                                    >
                                        <div className={styles['collapse-head']}>
                                            <div
                                                className={
                                                    classnames(styles['collapse-item-label'], {
                                                        [styles['collapse-item-label-checked']]: checked === index,
                                                    })}
                                                style={{
                                                    fontSize: l === 'cn' ? checked === index ? 24 : 16 : checked === index ? 20 : 16
                                                }}
                                            >
                                                {checked === index && <img src={collIcon} className={styles['collapse-icon']} alt='' />}
                                                <div>{item.label}</div>
                                            </div>
                                            <div
                                                className={styles['collapse-item-icon']}
                                                style={{
                                                    transform: checked === index ? 'rotate(180deg)' : 'none',
                                                }}
                                            >
                                                &nbsp;
                                            </div>
                                        </div>
                                        <div
                                            className={classnames(styles['collapse-content'], {
                                                [styles['collapse-content-show']]: checked === index,
                                            })}
                                            style={{
                                                lineHeight: l === 'cn' ? '28px' : '18px'
                                            }}
                                        >
                                            <div>
                                                {item.description}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className={styles['btn-box']}>
                                <Button title={text[l]['button']} onClick={() => {
                                    setPath('Customer Case');
                                }} />
                            </div>
                        </div>
                    </div>
                    <div className={styles['right']}>
                        <div className={styles['right-content']}>
                            <img className={styles['img']} src={text[l]['collapse'][checked].img} alt='' />
                            <img
                                className={styles['video-play-icon']}
                                src={videoPlayIcon}
                                onClick={() => {
                                    if (text[l]['collapse'][checked].video) {
                                        window.Player(text[l]['collapse'][checked].video)
                                    }
                                }}
                                alt=''
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomerStories;